import { generate } from 'shortid'

export const getKey = generate